module.exports = __webpack_public_path__ + "static/media/bd.c4a1485f.svg";